module.exports = __webpack_public_path__ + "2120b1d4ae9de091ac9d749285068f6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/faction_campaign_1-320.jpg
// module id = 280
// module chunks = 0